import { Box, Stack } from '@mui/material';
import React, { useState } from 'react';
import { isLocalHost } from '../../../helpers/environmentHelper';
import { useTranslation } from '../../../hooks/useTranslation';
import Button from '../Button/Button';
import Text from '../Text/Text';
import StyledCodeSnippet from '../CodeSnippet/StyledCodeSnippet';

const EmbedSnippet: React.FC = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const host = isLocalHost() ? 'http://localhost:3000' : 'https://app.elora.lu';

  const codeSnippet = `<script src="${host}/embed/elora-embed.js"></script>
<script>
  EloraEmbedInit({ host: '${host}' });

  document.getElementById('open-elora-btn').addEventListener('click', function () {
    EloraEmbed.open();
  });
</script>`;

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(codeSnippet);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy embed snippet:', err);
    }
  };

  return (
    <Stack spacing="1rem" width="100%">
      <Text type="body2">
        {t('Add this snippet to your website to open Elora in a modal.')}
      </Text>
      <Text type="body2">
        {t(
          'Use a button with id="open-elora-btn" or call EloraEmbed.open() from your own trigger.'
        )}
      </Text>
      <StyledCodeSnippet>
        <Box component="pre">
          <code>{codeSnippet}</code>
        </Box>
      </StyledCodeSnippet>
      <Button
        onClick={handleCopyCode}
        size="medium"
        type="button"
        disabled={false}
        color="primary"
        variant="outlined"
        style={{ backgroundColor: 'white' }}
      >
        {copied ? t('Copied!') : t('Copy Embed Snippet')}
      </Button>
    </Stack>
  );
};

export default EmbedSnippet;
